import { first } from "lodash-es";
import { objectKeys } from "../lib/object";
import { CustomClaimsTypesEnum } from "../lib/types";


export const MenuPropsForPermissionSelects = {
    PaperProps: {
        style: {
            maxHeight: 390,
            width: 250
        }
    },
    autoFocus: false
};

export const containsText = (text: string, searchText: string) => {
    if (text) return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
}

export interface ClaimsNotificationDialogState {
    open: boolean;
    title: string;
    itemsAdded: string[];
    itemsRemoved: string[];
}

export type ClaimKeyValuePair = { [key: string]: number; };

export interface ClaimWithPriority {
    claimEnum: ClaimKeyValuePair;
    priorityOfPermission: number;
};

export const claimFilters: CustomClaimsTypesEnum[] = Object.values(CustomClaimsTypesEnum)
    .filter((value): value is CustomClaimsTypesEnum => typeof value === 'number');

interface ClaimsMapping {
    [value: number]: ClaimKeyValuePair;
}

// Utility function to create the claims mapping
export const createClaimsMapping = (claims: ClaimKeyValuePair[]): ClaimsMapping => {
    const claimsMapping: ClaimsMapping = {};
    claims.forEach(claim => {
        const key = first(objectKeys(claim));
        if (key === void 0) return;
        const value = claim[key];
        if (value === void 0) return;
        claimsMapping[value] = { [key]: value };
    });
    return claimsMapping;
};